import gql from 'graphql-tag';

const CREATE_SECTOR_PICKING = gql`
    mutation createSectorPicking($input: SectorPickingInput) {
        createSectorPicking(input: $input) {
            internalCode
            id
        }
    }
`;

export default CREATE_SECTOR_PICKING;
